import { Field, Input, MessageBar, MessageBarBody } from '@fluentui/react-components';
import { HandWave20Regular } from '@fluentui/react-icons';
import { useT } from '@powerportalspro/react';
import { OperationButton, type OperationCompleted } from '@powerportalspro/react-fluent';
import { useState } from 'react';

// The demo's own code, registered on the server as an operation for everyone
// (AddOperationHandler<GreetingHandler>("DemoGreeting", o => o.ForEveryone()...)), so the button
// shows to every visitor. Clicking it sends the name typed here as the operation's Name parameter;
// the server answers the name and when it answered, which the page words as a greeting. Mirrors
// the Blazor `OperationButtonMainDemo`.

const STRINGS_BASE = 'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Common.OperationButtonMainDemo';

export function OperationButtonMainSample() {
  const t = useT();
  const [name, setName] = useState('');
  const [greeting, setGreeting] = useState<string>();

  const greeted = ({ outputs }: OperationCompleted) => {
    const answered = (outputs.Name as { value?: string } | undefined)?.value;
    const at = (outputs.AnsweredAt as { value?: string } | undefined)?.value;
    const time = at ? new Date(at).toLocaleTimeString(undefined, { timeZone: 'UTC' }) : '';
    setGreeting(t(`${STRINGS_BASE}.greeting`, [answered?.trim() || t(`${STRINGS_BASE}.stranger`), time]));
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacingVerticalM)' }}>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 'var(--spacingHorizontalS)', flexWrap: 'wrap' }}>
        <Field label={t(`${STRINGS_BASE}.name-label`)}>
          <Input value={name} onChange={(_, data) => setName(data.value)} />
        </Field>
        <OperationButton
          operation="DemoGreeting"
          label={t(`${STRINGS_BASE}.greet-label`)}
          icon={<HandWave20Regular />}
          appearance="primary"
          parameters={{ Name: { $type: 14, value: name } }}
          onCompleted={greeted}
        />
      </div>
      {greeting && (
        <MessageBar intent="success">
          <MessageBarBody>{greeting}</MessageBarBody>
        </MessageBar>
      )}
    </div>
  );
}
